module.exports = __webpack_public_path__ + "static/api-page-3-29b630caa52bc9634e0cffbe4e9b34bb.png";